import React from 'react';
import { connect } from 'react-redux';
import { selectPinnedVariables } from '@ff-scene-plugins/gift-redux/slices/variablesSlice';
import { GiftPdpState } from '@ff-scene-plugins/gift-redux/store';
import { GiftJson } from '@ff-scene-plugins/gift-shared/GiftJson';
import { Variables } from '../variables/Variables';

const _PinnedVariables = ({ pinnedVariables }: Props) => (
    <Variables variables={pinnedVariables} />
);

type Props = {
    pinnedVariables: GiftJson.Variable<any>[];
};

const mapStateToProps = (state: GiftPdpState) => ({
    pinnedVariables: selectPinnedVariables(state)
});

export const PinnedVariables = connect(
    mapStateToProps
)(_PinnedVariables);